import type { MetaState } from '../store.utils';

/** Сервисный экшен для проверки цепочки dispatch (без побочных эффектов). */
export const APP_PING = 'APP_PING';

export interface AppState {
  status: MetaState;
}

export type AppAction = { type: typeof APP_PING };
